/**
 * Created by lu on 2018/4/10.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    view:{
        'class': 'section section-brand',
        $html:{
            'class':'container',
            $html: [{
                'class': 'section-title',
                $html: [{
                    'class': 'title-cn',
                    $text:nb.bind('brandTitle')
                }, {
                    'class': 'title-en',
                    $text:nb.bind('brandTitleEn')
                }]
            }, {
                'class': 'brand-list',
                $html: {
                    'class':'clearfix',
                    $type:nb.view.List,
                    $model:''
                }
            }]
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/brand/BrandList.js
// module id = 512
// module chunks = 6